var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineDirectRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45 20.92C2.2 19.7 1.9 17.9 2.68 16.34L4.3 13.1c.34-.68.34-1.5 0-2.19L2.68 7.66C1.9 6.1 2.2 4.3 3.45 3.08c1.25-1.22 3.05-1.49 4.6-.67l11.59 6.1A3.93 3.93 0 0 1 21.75 12c0 1.47-.81 2.81-2.11 3.49l-11.59 6.1c-.6.32-1.23.47-1.86.47-1 0-1.97-.39-2.74-1.14zM4.5 4.16c-.62.6-1.06 1.67-.48 2.84l1.62 3.24c.55 1.11.55 2.42 0 3.53l-1.62 3.24c-.59 1.17-.14 2.24.48 2.84.62.6 1.69 1.03 2.85.42l11.59-6.1c.82-.43 1.31-1.24 1.31-2.16 0-.92-.49-1.73-1.31-2.16L7.35 3.73c-.4-.21-.79-.29-1.15-.29-.69 0-1.29.32-1.7.72z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineDirectRight);
export default __webpack_public_path__ + "static/media/vuesax-outline-direct-right.ceca449f0627cc2e8eecc5649b1c08b0.svg";
export { ForwardRef as ReactComponent };